/* eslint-disable @typescript-eslint/naming-convention */
import { MotorLabID } from 'src/api';

export const motorLabModel: MotorLabID = {
  data_id: '',
  max_speed: 0,
  component_type: 'MotorLabID',
};
